/* Unimaski product template — interactions */
(function () {
  'use strict';

  function initGallery(root) {
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = root.querySelectorAll('.unimaski-gallery__thumb[data-media-index]');
    var slides = track ? track.querySelectorAll('.unimaski-gallery__slide[data-media-index]') : [];
    var counter = root.querySelector('[data-gallery-counter]');
    var total = slides.length;

    function setActive(idx) {
      idx = String(idx);
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-index') === idx);
      });
      if (counter && total) {
        counter.textContent = String(parseInt(idx, 10) + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
      }
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-media-index');
        var slide = track ? track.querySelector('.unimaski-gallery__slide[data-media-index="' + idx + '"]') : null;
        if (slide && track) {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        setActive(idx);
      });
    });

    if (track && slides.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            setActive(entry.target.getAttribute('data-media-index'));
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { observer.observe(s); });
    }

    if (total) setActive(0);
  }

  function initOffers(root) {
    var offers = root.querySelectorAll('.unimaski-offer');
    var priceEl = root.querySelector('[data-active-price]');
    var stickyPriceEl = document.querySelector('.unimaski-sticky [data-active-price]');

    offers.forEach(function (offer) {
      offer.addEventListener('click', function (e) {
        offers.forEach(function (o) { o.classList.remove('is-selected'); });
        offer.classList.add('is-selected');
        var input = offer.querySelector('.unimaski-offer__radio-input');
        if (input) input.checked = true;
        var price = offer.getAttribute('data-price');
        if (price && priceEl) priceEl.textContent = price;
        if (price && stickyPriceEl) stickyPriceEl.textContent = price;
      });
    });
  }

  function initSticky() {
    var el = document.querySelector('[data-sticky-cta]');
    if (!el) return;
    var after = parseInt(el.getAttribute('data-show-after'), 10) || 600;
    el.hidden = false;
    var visible = false;
    function onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      var shouldShow = y > after;
      if (shouldShow !== visible) {
        visible = shouldShow;
        el.classList.toggle('is-visible', visible);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initReviewNav() {
    var track = document.querySelector('[data-review-track]');
    if (!track) return;
    var prev = document.querySelector('[data-review-prev]');
    var next = document.querySelector('[data-review-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }); });
  }

  function boot() {
    document.querySelectorAll('.unimaski-hero').forEach(function (hero) {
      initGallery(hero);
      initOffers(hero);
    });
    initSticky();
    initReviewNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
